import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Rewrite fragment (#) to query string (?)
if (window.location.hash && !window.location.search) {
  console.log('Original URL:', window.location.href); // Debug the original URL
  const hash = window.location.hash.substring(1); // Remove '#'
  const query = new URLSearchParams(hash).toString(); // Convert to query string
  const newUrl = `${window.location.pathname}?${query}`; // Replace hash with query
  console.log('Rewriting URL to:', newUrl); // Log rewritten URL
  window.history.replaceState(null, '', newUrl); // Update URL
}


// Rewrite fragment (#) to query string (?)
if (window.location.hash && !window.location.search) {
  console.log('Original URL:', window.location.href); // Debug the original URL
  const hash = window.location.hash.substring(1); // Remove '#'
  const query = new URLSearchParams(hash).toString(); // Convert to query string
  const newUrl = `${window.location.pathname}?${query}`; // Replace hash with query
  console.log('Rewriting URL to:', newUrl); // Log rewritten URL
  window.history.replaceState(null, '', newUrl); // Update URL
}

// Create root for React 18+
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);